export const FETCH_QUESTIONSCATEGORY_REQUEST = 'FETCH_QUESTIONSCATEGORY_REQUEST'
export const FETCH_QUESTIONSCATEGORY_SUCCESS = 'FETCH_QUESTIONSCATEGORY_SUCCESS'
export const FETCH_QUESTIONSCATEGORY_FAILURE = 'FETCH_QUESTIONSCATEGORY_FAILURE'
export const FETCH_QUESTIONSCATEGORY_UPDATE = 'FETCH_QUESTIONSCATEGORY_UPDATE'

